import { Component, Input, ViewChild, Renderer2, ViewEncapsulation } from "@angular/core";
import { saveAs } from '@progress/kendo-file-saver';
import { EmployeeDocumentBus } from "../../shared/models/EmployeeDocumentBus";
import { UntypedFormGroup, UntypedFormControl } from "@angular/forms";
import { GridComponent } from "@progress/kendo-angular-grid";
import { EmployeeService } from "../../shared/services/employee.service";
import { FileInfo } from '@progress/kendo-angular-upload';
import { CDocument } from "../../shared/models/CDocument";
import { DomSanitizer } from "@angular/platform-browser";
import { DropDownFilterSettings } from "@progress/kendo-angular-dropdowns";
import { BaseAppMComponent } from "../../shared/base-components/base-app-m.component";
import { GlobalsService } from "../../shared/services/globals.service";
import { DQOIReferenceDataQuery } from "../../dqoi/state/dqoi-reference-data.query";
import { CommonValues } from "../../shared/static/CommonValues";
import { CRUDActions } from "../../shared/enums/CRUDActions";
import { CPDialogResult } from "../../shared/enums/CPDialogResult";
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

const createFormGroup = dataItem => new UntypedFormGroup({
    'employeeDocumentId': new UntypedFormControl( ''),
    'updateDt': new UntypedFormControl( new Date()),
    'note': new UntypedFormControl( ''),
    'upload': new UntypedFormControl(''),
    'attachmentDetailFullName': new UntypedFormControl( '')
});

const hasClass = (el, className) => new RegExp(className).test(el.className);

const isChildOf = (el, className) => {
    while (el && el.parentElement) {
        if (hasClass(el.parentElement, className)) {
            return true;
        }
        el = el.parentElement;
    }
    return false;
};

@Component({
    selector: 'employee-documents',
    templateUrl: './employee-documents.component.html',
    styleUrls: ['./employee-documents.component.scss'],
    encapsulation: ViewEncapsulation.None,
    styles: [`
  .k-widget.k-upload .k-action-buttons {
    display: none;
  }
`],
    standalone: false
})
export class EmployeeDocumentsComponent extends BaseAppMComponent<null, EmployeeService, null, null> {
    dataLoading: boolean = false;
    updateEmployeeDocument: boolean = false;
    public employeeDocumentForm: UntypedFormGroup;
    private isNew: boolean;
    @Input() employeeId: string = '00000000-0000-0000-0000-000000000000';
    @ViewChild(GridComponent) private grid: GridComponent;
    private editedRowIndex: number;
    documentData: any = "";
    documentDataURL: any;
    document: CDocument;
    active: boolean = false;
    appCode = "Employee Document"
    public filterSettings: DropDownFilterSettings = {
        caseSensitive: false,
        operator: 'contains'
    };
    constructor(
        globals: GlobalsService,
        qry_rd: DQOIReferenceDataQuery,
        featureFlagService: FeatureFlagService,
        public svc_data: EmployeeService,

        private sanitizer: DomSanitizer,
        private renderer: Renderer2) { super(globals, featureFlagService, qry_rd);}
    employeeDocumentId: string;
    public addEmployeeDocument() {
        this.employeeDocumentId =  null;
        this.employeeDocumentForm.patchValue({
            note: "",
            employeeDocumentId: null,
            attachmentDetailFullName:"",

        })
        this.files = [];
        this.updateEmployeeDocument = true;
    }
    public clickEmployeeDocument({ isEdited, dataItem, rowIndex, column, columnIndex }, editClicked: boolean = false): void {
        if (columnIndex > 1) { return}
        this.employeeDocumentId = dataItem.employeeDocumentId
        this.employeeDocumentForm.patchValue({
            employeeDocumentId: dataItem.employeeDocumentId,
            attachmentDetailFullName: dataItem.attachmentDetailFullName,
            note: dataItem.note,

        })
        this.files = [];
        this.updateEmployeeDocument = true;
    }
    cancelUpdate(e: any) {
        this.closeUpdate();
    }
    closeUpdate() {
        this.updateEmployeeDocument = false;
    }
    deleteDialog(data: EmployeeDocumentBus) {

            this.cnfShow(CommonValues.Message_AreYouSureYouWantToDeleteThis, CRUDActions.Delete, data);
    }
    public ngOnInit(): void {
        this.employeeDocumentForm = createFormGroup({
            'employeeDocumentId': new UntypedFormControl(''),
            'updateDt': new UntypedFormControl(''),
            'note': new UntypedFormControl(''),
            'attachmentDetailFullName': new UntypedFormControl(''),
            'upload': new UntypedFormControl(''),

        });
        this.renderer.listen(
            "document",
            "click",
            ({ target }) => {
                if (!isChildOf(target, "k-grid")) {
                    this.saveClick();
                }
            });
    }

    CategorySearchFC(value: any) {}

    CategoryImportSearchVC(value: any) {

    }

    public saveClick(): void {
        if (this.employeeDocumentForm && !this.employeeDocumentForm.valid) {
            return;
        }
    }

    public saveCurrent(value: any): void {
        let busObj: EmployeeDocumentBus = new EmployeeDocumentBus();
        busObj.employeeDocumentId = this.employeeDocumentForm.controls['employeeDocumentId'].value;;
        busObj.employeeId = this.employeeId;
        busObj.note = this.employeeDocumentForm.controls['note'].value;
        busObj.attachmentDetailFullName = this.employeeDocumentForm.controls['attachmentDetailFullName'].value;
        busObj.updateDt = new Date();
        this.svc_data.saveEmployeeDocument(busObj).subscribe(
            data => this.employeeDocumentSaved(data, busObj),
            err => { this.CallFailed(err) });
        this.closeUpdate();
    }
    public deleteCurrent(id: any): void {

        this.svc_data.deleteEmployeeDocument(id).subscribe(
            data => {
                this.deleteSuccess();
                this.LoadEmployeeDocuments();
            },
            err => { this.CallFailed(err) });

    }
    confirmDialog(data: any) {

        let handled: boolean = false;
        if (data.dialogResult === CPDialogResult.ok) {

            this.deleteCurrent(data.data.employeeDocumentId);
        }
    }
    HasAttachment(dataItem: EmployeeDocumentBus) {

        return dataItem
            && dataItem.attachmentDetailFullName
            && dataItem.attachmentDetailFullName.length > 0;
    }

    download(data: EmployeeDocumentBus) {
        this.svc_data.getEmployeeDocument(data.employeeDocumentId).subscribe(
            {
                next:
                    data => {
                        this.document = new CDocument(data);
                        let downloadData = "data:" + this.document.mimeType + ";base64," + data.document;
                        saveAs(downloadData, this.document.fileName);
                    },
                error: err => {
                    console.error(err);
                    this.globals.notifyError("Error downloading document", true);
                 }
        });
    }
    hide() {
        this.active = false;
    }
    view(data: EmployeeDocumentBus) {
        this.dataLoading = true;
        this.svc_data.getEmployeeDocument(data.employeeDocumentId).subscribe(
            {
                next:
                    data => {
                        this.dataLoading = false;
                        this.document = new CDocument(data);
                        this.documentData = this.sanitizer.bypassSecurityTrustResourceUrl("data:" + this.document.mimeType + ";base64," + data.documentB64String);

                        var binary = atob(data.documentB64String.replace(/\s/g, ''));
                        var len = binary.length;
                        var buffer = new ArrayBuffer(len);
                        var view = new Uint8Array(buffer);
                        for (var i = 0; i < len; i++) {
                            view[i] = binary.charCodeAt(i);
                        }

                        this.documentDataURL = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(new Blob([view], { type: "application/pdf" })));
                        this.active = true;
                    },
                error: err => {
                    console.error(err);
                    this.dataLoading = false;
                    this.globals.notifyError("Error retrieving document for viewing", true);
                }
        });
    }
    employeeDocumentSaved(data: any, note: EmployeeDocumentBus) {
        let user = this.globals.user;
        console.log("saved: ", data);
        if (this.files && this.files.length) {
            this.svc_data.uploadEmployeeDocumentAttachment(this.files, data.employeeDocumentId).subscribe(
                data => this.employeeMentDocumentAttachmentSaved(data),
                err => { this.CallFailed(err) });
        }

                    else {
            this.saveSuccess();
            this.LoadEmployeeDocuments();
        }
    }

    public LoadEmployeeDocuments() {
        if (this.employeeId == '00000000-0000-0000-0000-000000000000') { return; }
        this.svc_data.getEmployeeDocuments(this.employeeId).subscribe(
            data => this.retrieveEmployeeDocumentSuccess(data),
            err => { this.CallFailed(err) });
    }

    retrieveEmployeeDocumentSuccess(data: any) {
        console.log("Employee Document data retrieved: ", data);
        this.svc_data.EmployeeDocumentData = data;
    }

    employeeMentDocumentAttachmentSaved(data: any) {
        this.saveSuccess();
        this.LoadEmployeeDocuments();
    }

    CallFailed(err) {
        console.error(err);
    }

    files: Array<FileInfo> = [];
    uploadSaveUrl: string = "http://localhost:53158/api/media/upload";//"http://18.188.111.206/cpiapi/api/media/upload";
    uploadRemoveUrl: string;
    uploadRestrictions: any;

    selectEventHandler(e: any) {
        this.files = e.files;
    }
    clearEventHandler(e: any) {

    }
    removeEventHandler(e: any) {

    }
    completeEventHandler(e: any) {

    }
}
